import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ReadMore extends ThemeComponent {
    @Prop() lineLimit!: string;
    @Prop() readMoreText!: string;
    @Prop() readLessText!: string;
    @Ref() text!: HTMLDivElement;

    private button!: HTMLButtonElement;

    init() {
        // If the -webkit-line-clamp is supported in the current browser
        if (this.lineLimit && CSS.supports("-webkit-line-clamp", this.lineLimit)) {
            // Add a button after the text
            const readMoreButton = document.createElement('button');
            readMoreButton.classList.add('read-more__button');
            readMoreButton.innerText = this.readMoreText;
            // Listen for clicks on the button and manage state
            this.$listen(readMoreButton, 'click', () => {
                if (this.classList.contains('read-more--active')) {
                    this.collapseText();
                    return;
                }
                this.expandText();
            });
            this.button = readMoreButton;
            // Append the button to the DOM
            this.appendChild(readMoreButton);
        }
    }

    // Expand text and update button text
    expandText() {
        this.classList.add('read-more--active');
        this.button.innerText = this.readLessText;
    }

    // Collapse text and update button text
    collapseText() {
        this.classList.remove('read-more--active');
        this.button.innerText = this.readMoreText;
    }

}
